/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { IconButtonProps } from '@coursera/cds-core';

import { CoachIconButton } from 'bundles/ai-coach-platform/components/building-blocks';
import { useQuickAccessContext } from 'bundles/ai-coach-platform/components/patterns/popover/context/quickAccessContext';

const styles = {
  button: css`
    --cds-border-radius-50: var(--cds-border-radius-100);
  `,
  selected: css`
    background-color: var(--cds-color-interactive-background-primary-hover-weak);
  `,
};

type Props = {
  selected?: boolean;
  icon: React.ReactElement;
  tooltip: string;
  'aria-label': string;
} & Omit<IconButtonProps, 'icon' | 'intent' | 'tooltip' | 'size' | 'aria-label'>;

/**
 * QuickAccessButton is a wrapper component on CoachIconButton with some style overrides.
 */
const QuickAccessButton = ({ selected, ...props }: Props) => {
  const { referenceProps } = useQuickAccessContext();

  return (
    <CoachIconButton
      {...props}
      {...referenceProps}
      selected={selected}
      size="small"
      css={[styles.button, selected && styles.selected]}
    />
  );
};

export default QuickAccessButton;
